import './index.scss';
import React from 'react';
import { Picker } from 'antd-mobile';
import moment from 'moment';

const format = (index) => {
  return index < 10 ? `0${index}` : `${index}`;
};

const seasons = [
  [
    ...Array.from({ length: 24 }).map((i, index) => ({
      label: format(index),
      value: format(index),
    })),
  ],
  [
    ...Array.from({ length: 60 }).map((i, index) => ({
      label: format(index),
      value: format(index),
    })),
  ],
  [
    ...Array.from({ length: 60 }).map((i, index) => ({
      label: format(index),
      value: format(index),
    })),
  ],
];

const Timepicker = (props) => {
  const { value, onChange, utc, children, disabled } = props;

  const pickerChange = (val) => {
    const [hour, minute, second] = val;
    let time = '';
    let _moment = moment(0);
    if (utc) {
      _moment = _moment.utc();
    }
    time = _moment.hour(hour).minute(minute).second(second).valueOf();
    onChange && onChange(time);
  };
  return (
    <div className="time-picker">
      <Picker
        disabled={disabled}
        extra="请选择(可选)"
        value={
          utc
            ? moment(value * 1000)
                .utc()
                .format('HH:mm:ss')
                .split(':')
            : moment(value).format('HH:mm:ss').split(':')
        }
        data={seasons}
        cascade={false}
        onOk={(e) => pickerChange(e)}
      >
        {children}
      </Picker>
    </div>
  );
};

export default Timepicker;
